/* The Internal View For All Videos */
import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { VideoContextWrapper } from "../context/video";
import { SelectedVideoV2 } from "../selectedVideoCardV2";
import { MainContainer } from "../../../../components/ContentWrapper";
import { ListPageHeader } from "../../../../components/ListPageHeader/ListPageHeader";
import { useCommonParams } from "../../../../hooks/useCommonParams";
import { VideoSection } from "../../../../components/videoSection/VideoSection";

export function AdminVideosV2() {
    const { searchParams, setSearchParams, searchText, setSearchText } = useCommonParams({});

    const videoId = useMemo(() => {
        const v = searchParams.get("video");
        return v ? parseInt(v, 10) || null : null;
    }, [searchParams]);

    const handleResetVideo = () => {
        setSearchParams((params) => {
            params.delete("video");
            params.delete("selectedTab");
            return params;
        });
    };

    return (
        <VideoContextWrapper>
            {videoId ? (
                <Box flexGrow={1}>
                    <SelectedVideoV2 videoId={videoId} onClose={handleResetVideo} type="file" refetch={() => {}} />
                </Box>
            ) : (
                <MainContainer>
                    <Box>
                        <ListPageHeader
                            title="Videos"
                            searchValue={searchText}
                            onSearchChange={setSearchText}
                            searchPlaceholder="Search videos"
                            searchInputId="search-videos"
                            searchDebounceMs={300}
                        />
                        <Box className="mt-2">
                            <VideoSection
                                defaultView="list"
                                features={{ sort: true, viewToggle: true, filters: true, nonProject: "always" }}
                                emptyTitle="No videos yet"
                                emptyBody="Videos appear here once a project reaches delivery."
                            />
                        </Box>
                    </Box>
                </MainContainer>
            )}
        </VideoContextWrapper>
    );
}
